import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import SearchResults from '../../SearchResults'
import ProductListingHeader from './ProductListingHeader'
const ProductPageHeader = () => {
  const pathName = usePathname()
  const [productListing, setProductListing] = useState<boolean | null>(null)

  useEffect(() => {
    const url = pathName
    const urlPath = url.split('/')
    if (
      urlPath.includes('buyers-listing') ||
      urlPath.includes('sales-listing')
    ) {
      setProductListing(true)
    } else {
      setProductListing(false)
    }
  }, [pathName])
  if (productListing === null) {
    return null
  }

  return productListing ? (
    <ProductListingHeader />
  ) : (
    <span>
      <SearchResults />
    </span>
  )
}

export default ProductPageHeader
